import Client from '../../../Client';
import BuildingEntityMockNamespace from './BuildingEntity';

export default class FloorsMockNamespace {
  dataSet = [
    {
      id: 1,
      name: 'Floor 1',
      building_id: 1,
      seq: 1,
      enabled: true,
      created: '2020-08-28T05:12:13.000Z',
      modified: '2020-08-28T05:12:13.000Z'
    },
    {
      id: 2,
      name: 'Floor 2',
      building_id: 1,
      seq: 2,
      enabled: true,
      created: '2020-08-28T11:53:56.000Z',
      modified: '2020-08-28T11:53:56.000Z'
    },
    {
      id: 3,
      name: 'Floor 3',
      building_id: 1,
      seq: 3,
      enabled: true,
      created: '2020-08-28T11:53:56.000Z',
      modified: '2020-08-28T11:53:56.000Z'
    },
    {
      id: 4,
      name: 'Floor 1',
      building_id: 2,
      seq: 1,
      enabled: true,
      created: '2020-08-28T05:12:13.000Z',
      modified: '2020-08-28T05:12:13.000Z'
    },
    {
      id: 5,
      name: 'Floor 2',
      building_id: 2,
      seq: 2,
      enabled: true,
      created: '2020-08-28T11:53:56.000Z',
      modified: '2020-08-28T11:53:56.000Z'
    },
    {
      id: 6,
      name: 'Floor 3',
      building_id: 2,
      seq: 3,
      enabled: true,
      created: '2020-08-28T11:53:56.000Z',
      modified: '2020-08-28T11:53:56.000Z'
    },
    {
      id: 7,
      name: 'Floor 1',
      building_id: 3,
      seq: 1,
      enabled: true,
      created: '2020-08-28T05:12:13.000Z',
      modified: '2020-08-28T05:12:13.000Z'
    },
    {
      id: 8,
      name: 'Floor 2',
      building_id: 3,
      seq: 2,
      enabled: true,
      created: '2020-08-28T11:53:56.000Z',
      modified: '2020-08-28T11:53:56.000Z'
    },
    {
      id: 9,
      name: 'Floor 3',
      building_id: 3,
      seq: 3,
      enabled: true,
      created: '2020-08-28T11:53:56.000Z',
      modified: '2020-08-28T11:53:56.000Z'
    }
  ];

  /** *
   * @param {Client} Client - instance of client
   * @param {MockFramework} Framework - instance of framework
   */
  constructor(Client, Framework) {
    this.client = Client;
    this.framework = Framework;
    this.buildingMocks = new BuildingEntityMockNamespace(Client, Framework);
  }

  getEndpoints() {
    return {
      'buildings/floors': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        userPermissions,
        error
      ) =>
        this.buildingMocks.search(
          this.dataSet,
          payload,
          headers,
          method,
          transmitType,
          isLoggedIn,
          userPermissions,
          error
        ),
      'buildings/floors/create': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        userPermissions,
        error
      ) =>
        this.buildingMocks.create(
          this.dataSet,
          'floor',
          payload,
          headers,
          method,
          transmitType,
          isLoggedIn,
          userPermissions,
          error
        ),
      'buildings/floors/update': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        userPermissions,
        error
      ) =>
        this.buildingMocks.update(
          this.dataSet,
          'floor',
          payload,
          headers,
          method,
          transmitType,
          isLoggedIn,
          userPermissions,
          error
        ),
      'buildings/floors/updateMultiple': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        userPermissions,
        error
      ) =>
        this.buildingMocks.updateMultiple(
          this.dataSet,
          'floor',
          payload,
          headers,
          method,
          transmitType,
          isLoggedIn,
          userPermissions,
          error
        ),
      'buildings/floors/delete': (
        payload,
        headers,
        method,
        transmitType,
        isLoggedIn,
        userPermissions,
        error
      ) =>
        this.buildingMocks.delete(
          this.dataSet,
          payload,
          headers,
          method,
          transmitType,
          isLoggedIn,
          userPermissions,
          error
        )
    };
  }
}
